module.exports = __webpack_public_path__ + "static/media/save-regular.9c3a5ad4.svg";